import { Injectable } from '@angular/core';
import { ApiMyInvoicesService } from '@core/api/services/my-invoices/api-my-invoices.service';
import { MyInvoicesListingMapper } from '@core/domain/mappers/invoices/my-invoices-listing.mapper';
import { errorFromHttpErrorResponse } from '@core/services/request/util/error-from-http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { myInvoicesActions } from '@store/actions/my-invoices.actions';
import { myInvoicesSelectors } from '@store/selectors/my-invoices.selector';
import { StoreState } from '@store/store.state';
import { catchError, map, of, switchMap } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';
import { masterSelectors } from '@store/selectors/master.selectors';

@Injectable()
export class MyInvoicesEffects {
  fetchListingData$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(myInvoicesActions.fetchListingData),
      withLatestFrom(this._store.select(masterSelectors.ggccSocieties)),
      switchMap(([, ggccSocieties]) =>
        this._apiService
          .fetchInvoices(
            MyInvoicesListingMapper.invoicesFilterFromDomainToApi(this._store.selectSignal(myInvoicesSelectors.listingDataFiltersSig)())
          )
          .pipe(
            map((value) => MyInvoicesListingMapper.invoicesRequestFromApiToDomain(value, ggccSocieties)),
            map((reponse) => reponse.data.values),
            map((data) => myInvoicesActions.setListingData({ data })),
            catchError((error) => of(myInvoicesActions.setListingDataError({ error: errorFromHttpErrorResponse(error) })))
          )
      )
    );
  });

  constructor(
    private readonly _actions$: Actions,
    private readonly _apiService: ApiMyInvoicesService,
    private readonly _store: Store<StoreState>
  ) {}
}
